import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/155afb533f1551d1a51d6aa70453bea0.js')["default"];

var scope_1 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f0acc74b72fd6a7e66a08e9754a5e2c.js')["default"];

var scope_2 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4ed3a6591f509b9da23055bd919e6da4.js')["default"];

var scope_3 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a2f37871e2a64ea9b996a836bdc766e2.js')["default"];

var scope_4 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aed0be9b4caccef861db54bd9a92c123.js')["default"];

var scope_5 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4f89bf44023517079139e83ff58a707.js')["default"];

var scope_6 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}